__turbopack_context__.v({
  "container": "Selfie-module-scss-module__GkrdDW__container",
  "imageContainer": "Selfie-module-scss-module__GkrdDW__imageContainer",
  "imagePlaceholderContainer": "Selfie-module-scss-module__GkrdDW__imagePlaceholderContainer",
});
